import getServiceStatusIcon from "./get-service-status-icon";
import { VImg } from "vuetify/lib";
import { gmapApi } from "vue2-google-maps";

export default {
	name: "KServiceStatusIcon",

	props: {
		size: {
			default: 24,
			type: Number
		},

		color: {
			required: true,
			type: String
		}
	},

	computed: {
		google: gmapApi,

		icon() {
			return getServiceStatusIcon( this.google, this.size, this.color ) || {};
		},

		iconUrl() {
			return this.icon.url;
		}
	},

	render() {
		if ( !this.iconUrl ) {
			return;
		}

		return <VImg
			contain
			height={this.size}
			src={this.iconUrl}
			width={this.size}
		></VImg>;
	}
};
